import React, { Component } from 'react';
import axios from 'axios';
import { setJSONLocalStorage, getJSONLocalStorage, getToken } from '../../functions/app_functions.js';
import Hero2 from './hero2.js';
import Tripcarousel from './tripcarousel.js';
import Usercarousel from './usercarousel.js';
import Destinationcarousel from './destinationcarousel.js';
import Howitworks from './howitworks.js';
import Valueprop from './valueprop.js';
import Testimonials from './testimonials.js';
import Video from "../../media/images/home/home_benefits.mp4"


export default class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Default states
            trips_most_views: [],
            trips_newest: []
        };

        this.baseUrl = this.props.baseUrl;

        this.loadTripsDataMostViews = this.loadTripsDataMostViews.bind(this);
        this.loadTripsDataNewest = this.loadTripsDataNewest.bind(this);
    }


    async componentDidMount() {
        this.loadTripsDataMostViews();
        this.loadTripsDataNewest();
    }


    async loadTripsDataMostViews() {
        try {
            var trips_most_views = getJSONLocalStorage("trips_most_views", 1);
            if (trips_most_views && trips_most_views.length > 0) {
                this.setState({
                    trips_most_views: trips_most_views.sort((a, b) => b.rate - a.rate)
                });
                this.props.unsetLoading();
            }
            // Send request
            var response = await fetch(this.props.baseUrl + "/gettripsmostviews", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${getToken()}`
                },
            });
            // Process response
            response = await response.json();
            var data = response.value;
            if (data) {
                // Set data to state
                this.setState({
                    trips_most_views: data.sort((a, b) => b.rate - a.rate)
                });
                setJSONLocalStorage("trips_most_views", data);
            } else {
                // Track error
                var name = "Server error";
                var message = "Could not load trip data. Please check the URL and try again.";
                this.props.setError(name, message);
            }
        } catch (error) {
            // Track error
            var name = "Server error";
            var message = "Could not load trip data. Please check the URL and try again.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Home_loadTripsDataMostViews");
        }
    }


    async loadTripsDataNewest() {
        try {
            var trips_newest = getJSONLocalStorage("trips_newest", 1);
            if (trips_newest && trips_newest.length > 0) {
                this.setState({
                    trips_newest: trips_newest
                });
                this.props.unsetLoading();
            }
            // Send request
            var response = await fetch(this.props.baseUrl + "/gettripsnewest", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${getToken()}`
                },
            });
            // Process response
            response = await response.json();
            var data = response.value;
            if (data) {
                // Set data to state
                this.setState({
                    trips_newest: data
                });
                setJSONLocalStorage("trips_newest", data);
            } else {
                // Track error
                var name = "Server error";
                var message = "Could not load trip data. Please check the URL and try again.";
                this.props.setError(name, message);
            }
        } catch (error) {
            // Track error
            var name = "Server error";
            var message = "Could not load trip data. Please check the URL and try again.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Home_loadTripsDataNewest");
        }
    }


    render() {

        return (
            <div className="content-container">

                {<Hero2
                    locations={this.props.locations}
                    locationcodes={this.props.locationcodes}
                    logEvent={this.props.logEvent}
                    goToPage={this.props.goToPage}
                    setError={this.props.setError}
                />}

                <Tripcarousel
                    label={"Explore all time favorites"}
                    link={"trips?sort=rated"}
                    data={this.state.trips_most_views}
                />

                <Tripcarousel
                    label={"Explore new additions"}
                    link={"trips?sort=newest"}
                    data={this.state.trips_newest}
                />

                <Valueprop
                />

                <div className="content-wrapper--wide">
                    <Destinationcarousel
                        label={"Explore destinations"}
                    />
                </div>

                {/* <Usercarousel
                    label={"Featured travelers"}
                    data={[1, 2, 3, 4, 5, 6, 7, 8]}
                /> */}

                <div className="content-wrapper">
                    <Howitworks
                    />
                </div>

                <div className="content-wrapper">
                    <Testimonials
                        data={this.props.testimonials}
                    />
                </div>


            </div >
        )
    }
}
